module.exports = __webpack_public_path__ + "static/media/wifi.2dd4abcf.gif";